module.exports = __webpack_public_path__ + "static/content-recommendation-2757a27cf396f38d01b29eba171b228e.svg";